const Inspection_constants = {
  GET_NOTPASSED_INSPECTION_SUCCESS: "GET_NOTPASSED_INSPECTION_SUCCESS",
  GET_NOTPASSED_INSPECTION_FAILURE: "GET_NOTPASSED_INSPECTION_FAILURE",
  GET_AUFTRAG_RECORD_SUCCESS: "GET_AUFTRAG_RECORD_SUCCESS",
  GET_AUFTRAG_RECORD_FAILURE: "GET_AUFTRAG_RECORD_FAILURE",
  UPDATE_RECORD_SUCCESS: "UPDATE_RECORD_SUCCESS",
  UPDATE_RECORD_FAILURE: "UPDATE_RECORD_FAILURE",
};
export default Inspection_constants;
